import { OrganizationMaterialSetEditResponse } from '@paragon/contract-library';
import { updateAlreadyLoadedOrganizationMaterialSet } from '@paragon/material-lists';

import { materialSetPrototypeLoaded } from '../store/materialSetPrototypeSlice';
import { ThunkActionVoid } from './thunkActionTypes';

export const receiveMaterialListEditResponse =
  (response: OrganizationMaterialSetEditResponse): ThunkActionVoid =>
  (dispatch) => {
    dispatch(materialSetPrototypeLoaded(response.prototype));
    dispatch(updateAlreadyLoadedOrganizationMaterialSet(response.result));
  };
